export default __webpack_public_path__ + "static/media/Icon1_On.e4e88bd7.png";